// extracted by mini-css-extract-plugin
module.exports = {"root":"ShoppingWidget2_root__csWwH","arrows":"ShoppingWidget2_arrows__brnEd","arrowNext":"ShoppingWidget2_arrowNext__RlV22","arrowPrev":"ShoppingWidget2_arrowPrev__QZJhZ"};